import React, { ChangeEvent } from "react";
import { Control, Controller, RegisterOptions } from "react-hook-form";

import { InputFieldWrapper, StyledInputField } from "../styles";
import { FieldWrapper, FieldWrapperProps } from "../FieldWrapper";
import { IFormFieldStyle } from "shared/types";

interface VATFieldProps extends FieldWrapperProps {
  control: Control;
  validation?: RegisterOptions;
  placeholder?: string;
  required?: boolean;
  disabled?: boolean;
  autocomplete?: string;
  defaultValue?: string;
  style?: IFormFieldStyle;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
}

export const VATField: React.FC<VATFieldProps> = ({
  control,
  name,
  style,
  error,
  disabled,
  defaultValue,
  validation,
  ...rest
}) => {
  return (
    <Controller
      control={control}
      name={name}
      rules={validation}
      defaultValue={defaultValue}
      render={({ onChange }) => (
        <FieldWrapper name={name} error={error} {...rest}>
          <InputFieldWrapper isDisabled={disabled} error={!!error}>
            <StyledInputField
              id={name}
              value={defaultValue}
              disabled={disabled}
              onChange={(event) => {
                event.persist();

                if (event.target.value) {
                  onChange(
                    event.target.value
                      .replaceAll(".", "")
                      .replaceAll("-", "")
                      .replaceAll(" ", "")
                  );

                  return;
                }

                onChange(null);
              }}
            />
          </InputFieldWrapper>
        </FieldWrapper>
      )}
    />
  );
};
